(ns teamoesterreich.admin-mode.crowdtasker.task-result.event-task-result-list
  (:require ["react-virtualized" :as rv]
            [clojure.string]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [reagent.core :as r]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.view-state :as vstate]
            [teamoesterreich.admin-mode.data.eventTask :as d-eventTask]

            [reagent-material-ui.icons.edit :refer [edit]]
            [reagent-material-ui.icons.add :refer [add]]
            [reagent-material-ui.icons.info :refer [info]]
            [reagent-material-ui.icons.cloud-download :refer [cloud-download]]
            ))




(defn status-cell-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)]
    (r/as-element
      [:span (if cell-data "Aktiv" "Entwurf")])))

(defn date-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)
        ;l-date (date-h/parse-local-date cell-data)
        ]
    ;(js/console.log l-date)
    (r/as-element
      [:span (if (> (count cell-data) 10)
               (str (subs cell-data 6 8) "." (subs cell-data 4 6) "." (subs cell-data 0 4))
               "-")])))

(defn date-time-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)]
    ;(js/console.log l-date)
    (if (> (count cell-data) 10)
      (r/as-element [:span (str (subs cell-data 6 8) "." (subs cell-data 4 6) "." (subs cell-data 0 4)) [:br] (str (subs cell-data 9 11) ":" (subs cell-data 11 13))])
      (r/as-element[:span"-"]))))


(defn edit-cell-renderer [!st]
  (fn [js-parm]
    (let [{cell-data "cellData"} (js->clj js-parm)]
      (r/as-element
        [mui/icon-button {:label "bearbeiten"
                          :onClick #(swap! vstate/app-state assoc
                                           :selected-task (get-in @!st [:data cell-data])
                                           :event-task-questions-loaded false
                                           :edit-crowdtaskerQuestion nil
                                           :event-task-loaded false
                                           :site :crowdtasker-task-result
                                           )
                          } [edit {:fontSize "small"}]]))))


(defn inside-table [!st rows ]

  (fn [m]
    (let [width (aget m "width")
          height (aget m "height")
          !sort (r/cursor !st [:sort])
          !reverse (r/cursor !st [:reverse])
          !detail-search (r/cursor !st [:detail-search])
          ]
      (r/as-element
        [:> rv/Table
         {:headerHeight 50
          :height (- height 250)
          :rowCount (count rows)
          :rowGetter (fn [i]
                       ;(println (str "rowGet " (aget i "index")))
                       (clj->js (nth rows (aget i "index"))))
          :rowClassName (fn [i] (when (odd? (aget i "index")) "table-odd"))
          :sort (fn [s] (swap! !st assoc :sort (aget s "sortBy") :reverse (= "DESC" (aget s "sortDirection"))))
          :sortBy @!sort
          :sortDirection (if @!reverse "DESC" "ASC")
          :rowHeight 45
          :width width
          :headerClassName "headerColumn"
          :className "CrowdTaskerTaskList"}
         (log/debug "rerender " m " @!sort " @!sort " @!reverse " @!reverse  rows)
         [:> rv/Column
          {:label     "Status"
           :dataKey   "user-tomId"
           :className "bordered exampleColumn"
           :style     #js {:overflow "hidden"}
           :cellRenderer status-cell-renderer
           :width     70}]
         [:> rv/Column
          {:label     "Aufgaben-Name"
           :dataKey   "crowdtaskerTask-name"
           :className "bordered exampleColumn"
           :style     #js {:overflow "hidden"}
           :width     170}]

         [:> rv/Column
          {:label     "Beginn"
           :dataKey   "_crowdtaskerTask-timeFrom"
           :className "bordered exampleColumn"
           :cellRenderer date-renderer
           :width     170}]
         [:> rv/Column
          {:label     "Ende"
           :dataKey   "_crowdtaskerTask-timeTo"
           :className "bordered exampleColumn"
           :cellRenderer date-renderer
           :width     170}]
         [:> rv/Column
          {:label     "Eingeladen"
           :dataKey   "_crowdtaskerTask-countMembers"
           :className "bordered exampleColumn"
           :width     170}]
         [:> rv/Column
          {:label     "Zusagen"
           :dataKey   "_crowdtaskerTask-countReplies"
           :className "bordered exampleColumn"
           :width     170}]
         [:> rv/Column
          {:label     "Fragen"
           :dataKey   "_crowdtaskerTask-countQuestions"
           :className "bordered exampleColumn"
           :width     170}]
         [:> rv/Column
          {:label        "#"
           :dataKey      (name :crowdtaskerTask-uuid)
           :className    "bordered exampleColumn"
           :cellRenderer (edit-cell-renderer !st)
           :width        70} ]
         ]))))



(defn get-table [!st rows]
  (fn [] [:> rv/AutoSizer
          {:style { :height "100%" :minHeight "400px"}}
          (inside-table !st rows)]))

(defn get-sort-filter-rows [rows sort_ reverse_ ]
  (js/console.log "get-sort-filter-rows = "  rows)
  (let [rows (if rows (mapv (fn [[k v]] (assoc v :index k)) rows) [])
        rows (sort-by (keyword (if sort_ sort_ :crowdtaskerTask-timeTo)) rows)
        rows (if reverse_ (reverse rows) rows)]
    rows))



(defn update-list [!st event-uuid]
  (d-eventTask/<get-event-task-list-elements event-uuid
                                             (fn [data]
                                               (swap! !st assoc
                                                      :event-uuid event-uuid
                                                      :data data
                                                      :loaded true
                                                      :count (count data)
                                                      )))
  )

(defn get-it [!event]
  (let [!st (r/cursor vstate/app-state [:event :crowdtaskerTask-list-state])
        !create-modal (r/cursor !st [:create-modal])
        !event-uuid (r/cursor !st [:event-uuid])
        !loaded? (r/cursor !st [:loaded])
        !data (r/cursor !st [:data])
        ]
    (fn []
      (let [event-uuid (:crowdtaskerEvent-uuid @!event)
            !sort (r/cursor !st [:sort])
            !reverse (r/cursor !st [:reverse])
            rows (get-sort-filter-rows @!data @!sort @!reverse)]
        (if-not (and @!loaded? (= event-uuid @!event-uuid))
          (do
            (update-list !st event-uuid)
            [:div {:style {:marginTop "100px"}} [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40}] "  loading..."])
          [mui/grid
           {:container true
            :direction "row"
            :alignItems "stretch"
            :justify "flex-start"
            :style {:height "calc(100% - 64px)" :minHeight "600px"}
            }


           [mui/grid
            {:item true
             :md 7
             :xs 3
             :style {:textAlign "right"} }
            ]

           [mui/grid
            {:item true
             :lg 12
             :xs 12
             :style {:textAlign "left"} }

            [(get-table !st rows )]
            ]

           ]
          )
        ))))















































